<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>교과서관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          컨텐츠관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/cs/textbook/">교과서관리</a>
        </li>
      </ol>
    </div>
    <!-- 검색  -->
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchSchoolType label="학교급" :data="data" @search="gradesearch" @reset="reset" :txt="'txt'" />
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->
    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="page-search mt-3 ml-3">
        <span class="d-inline-block">결과 내 검색</span>
        <input type="text" class="d-inline-block form-control ml-2" v-model="searchText" @change="SearchInPage(searchText,data.list)" name="updId" style="width: 200px"/>
        <div class="card-tool float-right">
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" @click="openAddPopup();" >+ 신규 교과서 등록</b-btn>
          <b-btn class="btn btn-xs btn-outline-info mr-2" v-b-modal.bookModal variant="outline-primary">Ycloud 교과서 불러오기</b-btn>
        </div>
      </div>
      <div class="card-header mt-2">
        목록
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td style="text-align:center">이미지</td>
            <td style="text-align:center" @click="localSort.sort('textbookNm')">교재명<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('author')">저자<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('pubDt')">개정년도<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('subjectCd')">과목<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('schoolGradeName')">학교급<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('regId')">등록자<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('updDt')">수정일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td width="90">자세히보기</td>
          </tr>
          </thead>
          <tbody>
          <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
          <tr v-show="searchText.length == 0" v-for="(item, index) in data.list" :key="index +'t'"
            @click="edit(item.bookSeq);">
            <td class="align-middle text-center"><img :src="data.aws_cdn_path + item.fileUrl" width="80"></td>
            <td class="align-middle">{{item.textbookNm}}</td>
            <td class="align-middle text-center">{{item.author}}</td>
            <td class="align-middle text-center">{{item.pubDt}}</td>
            <td class="align-middle text-center">
              <div v-for="(item1,index1) in subjectCd" :key="index1">
                <div v-if="item1.value == item.subjectCd">{{item1.text}}</div>
              </div>
              </td>
            <td class="align-middle text-center">
                {{item.schoolGradeName}}
            </td>
            <td class="align-middle text-center">{{item.regId}}</td>
            <td class="align-middle text-center">
              {{item.updDt}}
              <span class="updID">({{item.updId}})</span>
            </td>
            <td class="align-middle text-center">
              <div>
                <b-btn variant="outline-info mr-2" class="btn btn-sm btn-secondary" @click.prevent="edit(item.bookSeq);"><em class="fa fa-search"></em></b-btn>
              </div>
            </td>
          </tr>
          <tr v-show="searchText.length > 0 && searchValue.length == 0" class="text-center"><td colspan="9">No matching records</td> </tr>
          <tr v-show="searchText.length > 0 && searchValue.length > 0" v-for="(item, index) in searchValue" :key="index"
            @click="edit(item.bookSeq);">
            <td class="align-middle text-center"><img :src="data.aws_cdn_path + item.fileUrl" width="80"></td>
            <td class="align-middle">{{item.textbookNm}}</td>
            <td class="align-middle text-center">{{item.author}}</td>
            <td class="align-middle text-center">{{item.pubDt}}</td>
            <td class="align-middle text-center">
              <div v-for="(item1,index1) in subjectCd" :key="index1">
                <div v-if="item1.value == item.subjectCd">{{item1.text}}</div>
              </div>
            </td>
            <td class="align-middle text-center">
              {{item.schoolGradeName}}
            </td>
            <td class="align-middle text-center">{{item.regId}}</td>
            <td class="align-middle text-center">
              {{item.updDt}}
              <span class="updID">({{item.updId}})</span>
            </td>
            <td class="align-middle text-center">
              <div>
                <b-btn variant="outline-info mr-2" class="btn btn-sm btn-secondary" @click.prevent="edit(item.bookSeq);"><em class="fa fa-search"></em></b-btn>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

    <!-- 상세 -->
    <CsTextBookAddPage v-if="data.params.mode=='detail'" :bookSeq="data.detailBookSeq" @searchDepth="searchDepth" @search="search" :bookTypeCd='330001'/>
    <!-- // 상세 -->

    <!-- 단원/차시/개체 -->
    <div v-show="data.params.mode=='detail'" class="card card-default book-file">
      <div class="card-body" style="height:611.8px;">
        <div class="row">
          <div class="col-md-4">
            <p>단원
              <span class="float-right">
                <b-button @click=" popupShowDepth1 = true" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2" v-b-modal.uploadModalDepth1>+ 단원등록</b-button>
                <b-button v-show="!isShowDepth1" @click="clickChangeData('depth1'); isShowDepth1 = true;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2" >편집</b-button>
                <b-button v-show="isShowDepth1" @click="isShowDepth1= false; resetOrderNum('depth1'); editContSeq=0;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2" >취소</b-button>
                <b-button v-show="isShowDepth1" @click="isShowDepth1= false; saveChangeOrder('depth1'); " class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2" >저장</b-button>
              </span>
            </p>
            <table class="table table-striped table-hover">
              <tbody class="div_scroll">
              <tr v-show="atrbInfo.depth1.length==0" class="text-center">
                <td>No matching records</td>
              </tr>
              <draggable v-model="atrbInfo.depth1" :options="{group:'depth1', disabled:!isShowDepth1}"  @change="changeOrder(atrbInfo.depth1)">
                <tr v-for="(item, index) in atrbInfo.depth1"  :key="item.contSeq +'1'" :class="item.postTypeCd=='202004'?'.item addBtn':'.item'">
                  <td scope="row" @click="atrbInfo.targetContSeqDepth2=null;getDepth3(item.contSeq); SelectChangeColor('depth1',index);isShowDepth2=false;isShowfiles=false; selectUnitIndex[0] = index; selectedContSeq=item.contSeq;" :class="item.postTypeCd=='202004'?'table-info':''"  :style=" {backgroundColor: checkedDepth1[index] == true ? '#c1d5f8' : '' }" >
                    <div style="width: calc(100% - 100px);" v-show="editContSeq!=item.contSeq ">
                      <em v-show="item.postTypeCd == '202005'" class="fa fa-caret-right" ></em>
                      <span v-show="editContSeq!=item.contSeq">{{ item.title }}</span>
                    </div>
                     <b-button  v-show="item.postTypeCd == '202004' && editContSeq !=item.contSeq"  class="btn btn-xs btn-outline-info mr-2 additem" variant="outline-info mr-2"  @click="addUnit(item,item.orderNum,'depth1');popupShowDepthSmall = true">+ 단계등록</b-button>
                    <em class="fa fa-edit fa-pull-right" v-show="editContSeq!=item.contSeq" @click="editAttr(item.contSeq)" v-if="isShowDepth1"></em>
                    <b-input-group v-show="editContSeq==item.contSeq">
                      <b-form-input type="text" v-model="item.title"></b-form-input>
                      <b-input-group-append>
                        <b-btn class="btn btn-xs mr-2" variant="warning" @click="deleteAttr(data.row.contSeq, item.contSeq, item.orderNum, atrbInfo,'unit')">Delete</b-btn>
                        <b-btn class="btn btn-xs mr-2" variant="info" @click="saveAttr(item.title, item.pcontSeq); ">Save</b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  </td>
                </tr>
              </draggable>
              </tbody>
            </table>
          </div>
          <div class="col-md-4">
            <p>차시
              <span class="float-right" >
                <span class="float-right" >
                <b-button @click=" checkedDepth1Alert() ? popupShowDepth2 = true : popupShowDepth2 = false;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">+ 차시등록</b-button>
                <b-button v-show="!isShowDepth2"  @click="clickChangeData('depth2'); isShowDepth2 = true;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2" >편집</b-button>
                <b-button v-show="isShowDepth2" @click="resetOrderNum('depth2'); isShowDepth2 = false; editContSeq=0;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2" >취소</b-button>
                <b-button v-show="isShowDepth2" @click="saveChangeOrder('depth2'); isShowDepth2 = false;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2" >저장</b-button>
              </span>
              </span>
            </p>
            <table class="table table-striped table-hover">
              <tbody class="div_scroll">
              <tr v-show="atrbInfo.depth2.length==0" class="text-center">
                <td>No matching records</td>
              </tr>
                <draggable v-model="atrbInfo.depth2" :move="shouldDragToPosition" :options="{group:'depth2', disabled:!isShowDepth2}" @change="changeOrder(atrbInfo.depth2,'depth2')">
                  <tr v-for="(item,index) in atrbInfo.depth2"  :key="item.orderNum +'2'" :id="`${item.postTypeCd}_${item.contSeq}_${item.pcontSeq}`" :class="item.postTypeCd=='202006'?'addBtn':''">
                    <td scope="row" @click="getAtrbFiles(item.contSeq); isShowfiles=false; SelectChangeColor('depth2',index); selectUnitIndex[1] = index; selectedContSeq=item.contSeq;" :class="item.postTypeCd=='202006'?'table-primary':''" :style=" {backgroundColor: checkedDepth2[index] == true ? '#c4c1f8' : '' }">
                      <div style="width: calc(100% - 100px);" v-show="editContSeq!=item.contSeq ">
                        <em v-show="item.postTypeCd == '202007'" class="fa fa-caret-right"></em>
                        <span v-show="editContSeq!=item.contSeq ">{{ item.title }}</span>
                      </div>
                      <b-button v-show="item.postTypeCd == '202006' && editContSeq !=item.contSeq"  class="btn btn-xs btn-outline-info mr-2 additem" variant="outline-info mr-2"  @click="addUnit(item,item.orderNum,'depth2');popupShowDepthSmall = true">+ 코너등록</b-button>
                      <em class="fa fa-edit fa-pull-right" @click="editAttr(item.contSeq)" v-if="isShowDepth2 && editContSeq!=item.contSeq"></em>
                      <b-input-group v-show="editContSeq==item.contSeq">
                        <b-form-input type="text" v-model="item.title"></b-form-input>
                        <b-input-group-append>
                          <b-btn class="btn btn-xs mr-2" variant="warning" @click="deleteAttr(data.row.contSeq, item.contSeq,item.orderNum, atrbInfo, 'unit-seq')">Delete</b-btn>
                          <b-btn class="btn btn-xs mr-2" variant="info" @click="saveAttr(item.title, item.pcontSeq );">Save</b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </td>
                  </tr>
                </draggable>
              </tbody>
            </table>
          </div>
          <div class="col-md-4">
            <p>개체
              <span class="float-right">
                <b-button @click="checkedDepthFiles('4') ? popupShowDepthYfile = true : popupShowDepthYfile = false;" class="btn btn-xs btn-outline-dark mr-2" variant="outline-dark mr-2">Y 자료 복사</b-button>
                <b-button @click="checkedDepthFiles('3') ? popupShowDepth3 = true : popupShowDepth3 = false;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">개체등록</b-button>
                <b-button @click="checkedDepthFiles('4') ? popupShowDepth4 = true : popupShowDepth4 = false;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">개체연결</b-button>
                <b-button @click="checkedDepthFiles('6') ? popupShowDepth6 = true : popupShowDepth6 = false;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">온라인콘텐츠연결</b-button>
                <b-button @click="checkedDepthFiles('5') ? popupShowDepth5 = true : popupShowDepth5 = false;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">용도변경</b-button>
                <b-button v-show="!isShowfiles"  @click="clickChangeData('file'); isShowfiles = true;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">편집</b-button>
                <b-button v-show="isShowfiles" @click="resetOrderNum('file'); isShowfiles = false; editContSeq=0;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">취소</b-button>
                <b-button v-show="isShowfiles" @click="saveChangeOrder('file'); isShowfiles = false;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2" >저장</b-button>
              </span>
            </p>
            <table class="table table-striped table-hover">
              <tbody class="div_scroll">
              <tr v-show="atrbInfo.files.length == 0 || atrbInfo.files.length == null  " class="text-center">
                <td>No matching records</td>
              </tr>
              <draggable v-model="atrbInfo.files" :options="{group:'files', disabled:!isShowfiles}" @change="changeOrder(atrbInfo.files,'depth3');checkColor(atrbInfo.files);">
              <tr v-for="(item,index) in atrbInfo.files"  :key="item.fileSeq +'3'">
                <b-btn class="btn btn-xs mr-2 btn-down" v-show="editContSeq!=item.fileSeq && item.fileTypeCd != '211006' ? true : false" @click="popupShowFile = false; downloadAs(item.fileDivCd,item.url,item.orgFileNm)" />
                <em class="fa fa-edit fa-pull-right mr-2" style="margin-top: 1.25em;" @click="editAttr(item.fileSeq)" v-if="isShowfiles" v-show="editContSeq!=item.fileSeq "></em>
                <td class="file" scope="row" @mousemove="findFile(item.fileSeq);" @click="popupFile(atrbInfo.fileSeq ,item.fileSeq,item.mappingSeq)">
                  <a variant="outline-info mr-2" v-show="editContSeq!=item.fileSeq"  >{{ item.dispFileNm }}</a>
                    <b-input-group v-show="editContSeq==item.fileSeq" @click="atrbInfo.fileSeq = 0;">
                      <b-form-input type="text" v-model="item.dispFileNm"></b-form-input>
                      <b-input-group-append>
                        <b-btn class="btn btn-xs mr-2" variant="warning" @click="popupShowFile = false;deleteAttr(data.row.contSeq, item.mappingSeq , item.orderNum, atrbInfo, 'file')">Delete</b-btn>
                        <b-btn class="btn btn-xs mr-2" variant="info" @click="saveAttrFile(item.dispFileNm, item.pcontSeq, item );">Save</b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  <div class="file-kind-wrap">
                    <div class="file_kind" v-show="editContSeq!=item.fileSeq">
                      <span v-show="item.purpTypeCd != null ? true : false " :style="{color: atrbInfo.contColor[index]}">{{atrbInfo.contKind[index]}}</span>
                      <span v-show="item.teacherUseYn == 'Y' ? true : false " :style="{color: item.teacherUseYn == 'Y' ? '#FF0000' : '' }">교사</span>
                      <span v-show="item.tutorUseYn == 'Y' ? true : false " :style="{color: item.tutorUseYn == 'Y' ? '#708090' : '' }">강사</span>
                      <span v-show="item.studentUseYn == 'Y' ? true : false " :style="{color: item.studentUseYn == 'Y' ? '#800000' : '' }">학생</span>
                    </div>
                    <div class="file_kind" v-show="editContSeq!=item.fileSeq">
                      <span v-show="item.fileTypeCd == '211006' ? true : false">(온라인 콘텐츠)</span>
                      <span v-show="item.fileTypeCd == '211005' ? true : false">(웹콘텐츠)</span>
                      <span v-show="item.fileTypeCd == '211004' ? true : false">(웹콘텐츠링크)</span>
                      <span v-show="item.fileTypeCd == '211003' ? true : false">(외부링크)</span>
                      <span v-show="item.ext != null  ? true : false">({{item.ext}})</span>
                      <span v-show="item.playEndTime != '0' ? true : false ">({{item.playStartTime}} ~ {{item.playEndTime}})</span>
                    </div>
                  </div>
                </td>
              </tr>
              </draggable>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- // 단원/차시/개체 -->

    <!-- Modals -->
    <b-modal id="bookModal" size="xl" title="Ycloud교재 리스트">
      <YcloudTextbookMstPage :bookId="data.row.bookId" @saveYcloudBook="saveYcloudBook"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="addBookModal" size="xl" title="교과서 등록" v-model="popupShowDepthAddBook" hide-footer>
      <CsTextBookAddPage @search="search" @modal-state="popupClose" :bookTypeCd='330001'/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="fileModal" size="xl" title="개체정보" v-model="popupShowFile">
      <CsFilePageInfo :fileSeq="atrbInfo.fileSeq" :mappingSeq="atrbInfo.mappingSeq" :contSeq="atrbInfo.targetContSeqDepth2 == null ? atrbInfo.targetContSeqDepth1 : atrbInfo.targetContSeqDepth2" :orgContSeq="data.row.contSeq" :isShow="isShow" :atrbInfo="atrbInfo" @modal-state="popupClose" @get-data="GetDepthData" :saveType="'txt'" :parentType="'txt'"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="fileRegModal" size="xl" title="개체등록" v-model="popupShowDepth3" hide-footer>
      <CsFileUploadPage :contSeq="atrbInfo.targetContSeqDepth2 == null ? atrbInfo.targetContSeqDepth1 : atrbInfo.targetContSeqDepth2" :orgContSeq="data.row.contSeq" :isShow="isShow" :selectedContSeq="selectedContSeq" :atrbInfo="atrbInfo" @get-data="refreshFiles" @modal-state="popupClose" :saveType="'txt'"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="usingModalFiles" size="xl" title="개체용도변경" v-model="popupShowDepth5" hide-footer>
      <CsFileUsingPage :filedata="atrbInfo.files" :postTypeCd="atrbInfo.targetPostTypeCd" :atrbInfo="atrbInfo" :index="selectUnitIndex" :title="data.row.textbookNm" :pContSeq1="atrbInfo.targetContSeqDepth1" :pContSeq2="atrbInfo.targetContSeqDepth2" :orgContSeq="data.row.contSeq" :isShow="isShow" @refresh-files="GetDepthData" @modal-state="popupClose" />
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
     <b-modal id="unitModalDepth" size="ll" title="하위등록" v-model="popupShowDepthSmall" hide-footer >
      <CsUnitPage :fileSeq="atrbInfo.fileSeq" :param="saveUnitInfo" :atrbInfo="atrbInfo" @modal-state="popupClose" @title-push="PushItem" />
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="uploadModalDepth1" size="ll" title="단원등록" v-model="popupShowDepth1" hide-footer >
      <CsUploadpage :fileSeq="atrbInfo.fileSeq" :orderNum="atrbInfo.depth1.length" :version="unit" :atrbInfo="atrbInfo" :pContSeq="data.row.contSeq" :orgContSeq="data.row.contSeq" @title-push="PushItem" @modal-state="popupClose" />
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="uploadModalDepth2" size="ll" title="차시단계등록" v-model="popupShowDepth2" hide-footer>
      <CsUploadpage :fileSeq="atrbInfo.fileSeq" :orderNum="atrbInfo.depth2.length" :version="unit_seq" :atrbInfo="atrbInfo" :pContSeq="atrbInfo.targetContSeqDepth1" :orgContSeq="data.row.contSeq" @title-push="PushItem" @modal-state="popupClose"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="uploadModalFiles" size="xl" title="개체연결" v-model="popupShowDepth4">
      <CsTextBookFiles :extFileId="data.row.extFileId" :atrbInfo="atrbInfo" :pContSeq1="atrbInfo.targetContSeqDepth1" :pContSeq2="atrbInfo.targetContSeqDepth2" :orgContSeq="data.row.contSeq" @get-data="getDepthData"  @modal-state="popupClose"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
   <b-modal id="uploadModalFiles" size="xl" title="온라인콘텐츠연결" v-model="popupShowDepth6">
      <CsTextBookFilesOnline :extFileId="data.row.extFileId" :atrbInfo="atrbInfo" :pContSeq1="atrbInfo.targetContSeqDepth1" :pContSeq2="atrbInfo.targetContSeqDepth2" :orgContSeq="data.row.contSeq" @get-data="getDepthData"  @modal-state="popupClose"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="uploadModalFiles" size="xl" title="Y 클라우드 자료 복사" v-model="popupShowDepthYfile">
      <YCsTextBookFiles :bookId="data.row.bookId" :bookName="data.row.textbookNm" :extFileId="data.row.extFileId" :atrbInfo="atrbInfo" :pContSeq1="atrbInfo.targetContSeqDepth1" :pContSeq2="atrbInfo.targetContSeqDepth2" :orgContSeq="data.row.contSeq" @get-data="getDepthData"  @modal-state="popupClose"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <loading :active="data.params.isLoading" :is-full-page="true"/>
  </ContentWrapper>
</template>
<script>
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount} from '@vue/composition-api'
import {getLmTextBookList,getLmTextBookItem,saveLmTextBook,deleteLmTextBook, saveTextbook,getLmTextBookListSchlGrade} from "@/api/lm/LmTextBookApi";
import {getTextbookAtrbRelInfoList} from "@/api/ext/TextbookAtrbRelInfoApi";
import {getContentsMstList} from "@/api/ext/ContentsMstApi"
import {getCsContList, getCsContTreeList, getCsContItem, saveCsCont, deleteCsCont, saveCsContList,saveCsContExcel, deleteCsContByOrgContSeq} from "@/api/cs/CsContApi";
import {getCsFileList, getCsFileListByMapp, saveCsFile} from "@/api/cs/CsFileApi";
import {saveCsFileMapping, saveCsFileMappingList,deleteCsFileMapping} from "@/api/cs/CsFileMappingApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject,bookTypeCd,subjectCd,subjectCd1,subjectCd2,subjectCd3,aws_cdn_path, getSchoolGradeName} from "@/utils/Constants";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import Keyword from "../../components/Common/Keyword";
import SchSchoolType from "../../components/Common/SchSchoolType";
import YcloudTextbookMstPage from "../ext/YcloudTextbookMstPage"
import CsTextBookAddPage from "../cs/CsTextBookAddPage"
import CsFilePageInfo from "../cs/CsFilePageInfo"
import CsUploadpage from "../cs/CsUploadPage"
import CsUnitPage from "../cs/CsUnitPage"
import CsFileUploadPage from "../cs/CsFileUploadPage"
import CsFileUsingPage from "../cs/CsFileUsingPage"
import CsTextBookFiles from "../cs/CsTextBookFiles"
import YCsTextBookFiles from "../cs/YCsTextBookFiles"
import CsTextBookFilesOnline from "../cs/CsTextBookFilesOnline"
import swal from 'sweetalert2'
import Axios from 'axios';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import draggable from 'vuedraggable'
// 목차/차시/파일

export default {
  components: {SchDateRange, SchText,Keyword, SchSchoolType, Pagenation, YcloudTextbookMstPage, CsUploadpage,CsUnitPage, CsFileUsingPage,CsTextBookFiles,YCsTextBookFiles,CsTextBookAddPage, CsFilePageInfo, CsFileUploadPage, CsTextBookFilesOnline, Loading, draggable},

  setup(props, {root}){
    const selectedContSeq = '';
    const unit = "unit";
    const unit_seq = "unit_seq";
    const isShow = true;
    const isShowDepth1 = false;
    const isShowDepth2 = false;
    const isShowfiles = false;
    const popupShowDepth1 = ref(false);
    const popupShowDepthSmall = ref(false);
    const popupShowDepth2 = ref(false); 
    const popupShowDepth3 = ref(false); //개체등록
    const popupShowDepth4 = ref(false); //개체연결
    const popupShowDepthYfile = ref(false); //Y자료복사
    const popupShowDepth5 = ref(false); //개체용도변경
    const popupShowDepth6 = ref(false); //온라인콘텐츠
    const popupShowFile = ref(false); //개체정보
    const popupShowDepthAddBook = ref(false);
    const checkedDepth1 = reactive([]);
    const checkedDepth2 = reactive([]);
    const checkedDepth3 = reactive([]);

    const contKind = ref([]);
    const contColor = ref([]);

    const searchText = ref('');
    const searchValue = ref([]);
    const searchShowValue = ref([]);

    const schOptions = [{value:'textbook_nm',text:'교재명'},{value:'author',text:'저자'},{value:'book_id',text:'교재ID'}]
    const _dataObject = _.cloneDeep(dataObject);
    _dataObject.detailBookSeq = 0;
    const data = reactive(_dataObject)

    const tempData = []; //변경될 값 
    const changeData = []; //취소될 값 

    const selectUnitIndex = []; //선택한 단원차시 index

    data.schOptions = schOptions // 검색 type 선택
    data.aws_cdn_path = aws_cdn_path


    const atrbInfo = reactive({
      result:{},
      depth1:[], // 단원, 목차
      depth2:[], // 차시, 코너
      files:[],  // 개체
      fileSeq:'',
      mappingSeq:'',
      contKind,
      contColor,
      contSeq:Number,
      targetContSeqDepth1:-1,
      targetContSeqDepth2:-1,
      targetPostTypeCd : '',
    })

    const saveUnitInfo = reactive({
      data: {},
      depth : '',
      orderNum : '',
    })

    const loadData = async () => {
      data.params.bookTypeCd = '330001';
      const result = await getLmTextBookList(data.params);
      data.list = result.data;
      data.list.forEach((item) => {
        item.schoolGradeName = getSchoolGradeName(item);
      })
      data.count = result.count;
      root.$_localSort.set(data.list);
      searchValue.value = _.cloneDeep(data.list);
    }


    const popupClose = (version) =>{ //b-modal 팝업 닫는 함수
      if(version == "unit"){
        popupShowDepth1.value = false;
      }
      else if(version == "unit_seq"){
        popupShowDepth2.value = false;
      }
      else if(version == 'under'){
        popupShowDepthSmall.value = false;
      }
      else if(version == 'file'){
        popupShowDepth5.value = false;
      }
      else if(version == 'file2'){
        popupShowDepth4.value = false;
      }
      else if(version == 'yfile'){
        popupShowDepthYfile.value = false;
      }
      else if(version == 'addfile'){
        popupShowDepth3.value=false;
        loadData();
      }
      else if(version == 'fileOnline'){
        popupShowDepth6.value = false;
      }
      else if(version == 'info'){
        popupShowFile.value=false;
      }
      else if(version == 'addTextBook'){
        popupShowDepthAddBook.value = false;
      }
      else{
        popupShowDepth4.value = false;
      }
    }
    // 팝업 닫고 단원/차시/개체 모두 리프레시
    const GetDepthData = (item) => {
      if(item.version == 'addfile'){
        popupShowDepth3.value=false;
      }else{
        popupShowFile.value=false;
      }
        methods().getDepthData(item);
    }

    // 개체등록 팝업 닫고 개체만 리프레시
    const refreshFiles = (item) => {
      popupShowDepth3.value = false;
   
      methods()._getAtrbFiles(item);
    }

    const PushItem = (item) => {
          methods().saveUploadlist(item , item.inputVersion);

        if(item.version == "unit"){
          popupShowDepth1.value = false;
        } 
        else if(item.version == "unit_seq"){
          popupShowDepth2.value = false;
        }
        else if(item.version == 'under'){
          popupShowDepthSmall.value = false;
        }
        else{
          popupShowDepth4.value = false;
        }
    }
        
    const SelectChangeColor = (version,index) => {
      if( version == "depth1"){
        atrbInfo.depth1.forEach(function(e,i){
          checkedDepth1[i] = false;
        });
        checkedDepth2.splice(0,checkedDepth2.length);
        checkedDepth3.splice(0,checkedDepth3.length);

        checkedDepth1[index] = true;

        atrbInfo.targetContSeqDepth1 = atrbInfo.depth1[index].contSeq;
        atrbInfo.targetPostTypeCd = '202004';
      } 
      else if( version == 'depth2' ){
        atrbInfo.depth2.forEach(function(e,i){
          checkedDepth2[i] = false;
        });
        checkedDepth3.splice(0,checkedDepth3.length);

        checkedDepth2[index] = true;
        atrbInfo.targetContSeqDepth2 = atrbInfo.depth2[index].contSeq;
        atrbInfo.targetPostTypeCd = '202006';
      }
      else{
        atrbInfo.files.forEach(function(e,i){
          checkedDepth3[i] = false;
        });
        checkedDepth3[index] = true;
      }
    }

    const addUnit = (item,orderNum,depth) =>{
      saveUnitInfo.data = item;
      saveUnitInfo.depth = depth;
      saveUnitInfo.orderNum = orderNum;
    }

    const checkedDepth1Alert = () => {
      let isFalse = true;
      checkedDepth1.forEach(function(_arr){
        if(_arr){
          isFalse = false;
        }
      });
      if(isFalse){
        alert("등록할 단원을 선택해주세요.");
        return false;
      }
      else{
        return true;
      }
    };

    const checkedDepthFiles = (type) => {
      if(type == '5'){
        if(atrbInfo.files.length == 0 || selectUnitIndex[0] == null){
          alert("용도변경 가능한 개체가 없습니다.");
          return false;
        }
        else{
          return true;
        }
      // } else if (type == '3') { // [개체등록] 는 단원 선택 없이 교과서에 등록가능.
      } else if (type == '3' || type == '4') { // [개체등록/개체연결/Y 자료 복사] 는 단원 선택 없이 교과서에 등록가능.
          return true;
      }
      else{
        if(checkedDepth1.length == 0){
          alert("개체 등록을 위한 단원 선택해주세요.");
          return false;
        }
        else{
          return true;
        }
      }
    }

    const SearchInPage = (text , datalist) =>{  //결과 내 검색
      searchValue.value = [];

      let arr = text.split(' ');
      const textlist = arr.filter((value, index, array) => array.indexOf(value) == index); 
      
      
      let data  = _.cloneDeep(datalist);
      textlist.map((row,i)=>{
        if(row != ''){
          data.filter(value => {
            if(value.textbookNm.indexOf(row) >= 0){
              searchValue.value.push(value);
              return value;
            }
            else if(value.author.indexOf(row) >= 0){
              searchValue.value.push(value);
              return value;
            }
            else if(value.pubDt.indexOf(row) >= 0){
              searchValue.value.push(value);
              return value;
            }
            else if(value.subjectCd.indexOf(row) >= 0){
              searchValue.value.push(value);
              return value;
            }
            else if(value.regId.indexOf(row) >= 0){
              searchValue.value.push(value);
              return value;
            }

            if(row.indexOf('초') >= 0){ //학교급 체크 로직
              switch(row){
                case '초' :
                  if(value.schlE1ChkYn == 'Y' || value.schlE2ChkYn == 'Y' || value.schlE3ChkYn == 'Y' || value.schlE4ChkYn == 'Y' || value.schlE5ChkYn == 'Y' || value.schlE6ChkYn == 'Y' ){
                    searchValue.value.push(value);
                    return value;
                  }
                  break;

                case '초1' :
                  if(value.schlE1ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                break;

                case '초2' :
                  if(value.schlE2ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                  break;

                case '초3' :
                  if(value.schlE3ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                  break;

                case '초4' :
                  if(value.schlE4ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                  break;

                case '초5' :
                  if(value.schlE5ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                  break;

                case '초6' :
                  if(value.schlE6ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                  break; 
              }
            }else if(row.indexOf('중') >= 0){
              switch(row){
                case '중' :
                  if(value.schlM1ChkYn == 'Y' || value.schlM2ChkYn == 'Y' || value.schlM3ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                break;

                case '중1' :
                  if(value.schlM1ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                break;

                case '중2' :
                  if(value.schlM2ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                  break;

                case '중3' :
                  if(value.schlM3ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                  break;
              }

            }else if(row.indexOf('고') >= 0){
              switch(row){
                case '고' :
                  if(value.schlH1ChkYn == 'Y' || value.schlH2ChkYn == 'Y' || value.schlH3ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                break;
                case '고1' :
                  if(value.schlH1ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                break;
                case '고2' :
                  if(value.schlH2ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                break;

                case '고3' :
                  if(value.schlH3ChkYn == 'Y'){
                    searchValue.value.push(value);
                    return value;
                  }
                  break;

              }

            }
          });
          
        }
        checkDupliValue();
      });
    }

    const checkDupliValue = () => { 
      searchShowValue.value = [];
      
      let _temp;
      if(searchShowValue.value.length > 0){
        _temp = (searchValue.value.filter( x=> !searchShowValue.value.includes(x)) ); 
        _temp.map((row , i) => {
          if(row.fileSeq != null){
            searchShowValue.value.push(row); 
          }
        });
      }
      else{
        searchShowValue.value = _.cloneDeep(searchValue.value);
      }
    }

    const openAddPopup = async() =>{
      popupShowDepthAddBook.value = true;
    }

    const checkColor = (data) =>{
      data.map((row, i) =>{
        switch(row.purpTypeCd){
          case '209001' : 
          contKind.value[i]='수업용1';
          contColor.value[i]="#008000";
          break;

          case '209002' :
          contKind.value[i]='수업용2';
          contColor.value[i]="#0000FF";
          break;

          case '209003' : 
          contKind.value[i]='과제용';
          contColor.value[i]="#800080";
          break;

          case '209004' :
          contKind.value[i]='평가용';
          contColor.value[i]="#FF8C00";
          break;

          case '209005' : 
          contKind.value[i]='연구용';
          contColor.value[i]="#FF00FF";
          break;   
        }
        if (row.purpTypeCd == '209007' || (row.purpTypeCd||'').startsWith('6')) {
          contKind.value[i]='부가자료';
          contColor.value[i]="#FF00FF";
        }
      });
    };

    const popupFile = (editContSeq,fileSeq,_mappingSeq) =>{
      if(editContSeq == fileSeq){
        atrbInfo.mappingSeq = _mappingSeq;
        popupShowFile.value = true;
      }else{
        popupShowFile.value = false;
      }
    }

    onMounted(loadData)

    return{
      data,
      selectedContSeq,
      bookTypeCd,
      subjectCd,
      checkedDepth1,
      checkedDepth2,
      checkedDepth3,
      searchValue,
      searchText,
      contKind,
      contColor,
      changeData,
      tempData,
      checkedDepth1Alert,
      checkedDepthFiles,
      selectUnitIndex,
      SearchInPage,
      searchShowValue,
      checkDupliValue,
      ...methods(),
      dataAction: new TableActionClass(data),
      localSort:root.$_localSort,
      modalLoading: false,
      atrbInfo,
      saveUnitInfo,
      bookId:'',
      editContSeq:0,
      isShowDepth1,
      isShowDepth2,
      isShowfiles,
      unit,
      unit_seq,
      popupClose,
      popupShowDepth1,
      popupShowDepth2,
      popupShowDepth3,
      popupShowDepth4,
      popupShowDepthYfile,
      popupShowDepth5,
      popupShowDepth6,
      popupShowFile,
      popupShowDepthSmall,
      popupShowDepthAddBook,
      PushItem,
      GetDepthData,
      refreshFiles,
      isShow,
      SelectChangeColor,
      addUnit,
      checkColor,
      openAddPopup,
      popupFile,
    }
  },
}

function methods() {
  var context = {};
  context["getLmTextBookList"] = getLmTextBookList;  // get list
  context["getLmTextBookItem"] = getLmTextBookItem;  // get item
  context["deleteLmTextBook"] = deleteLmTextBook;  // delete item
  context["saveLmTextBook"] = saveLmTextBook;  // save item
  context["saveCsCont"] = saveCsCont;  // save Cont item
  context["deleteCsCont"] = deleteCsCont;  // delete Cont item
  context["saveCsContList"] = saveCsContList;  // save item 
  context["saveCsContExcel"] = saveCsContExcel;  // save item 
  context["deleteCsContByOrgContSeq"] = deleteCsContByOrgContSeq;  // delete Cont item
  context["saveCsFileMapping"] = saveCsFileMapping; // save mapping info
  context["saveCsFileMappingList"] = saveCsFileMappingList; // save mapping info list
  context["getLmTextBookListSchlGrade"] = getLmTextBookListSchlGrade; // save mapping info list
  context["getContentsMstList"] = getContentsMstList; // get textbookContents list
  context["deleteCsFileMapping"] = deleteCsFileMapping; // save mapping info list

  function setResultDataList(result) {
    this.data.list = result.data;
    this.data.count = result.count;
    this.data.params.mode = 'list';
    this.data.row = {};
    this.data.list.forEach((item) => {
      item.schoolGradeName = getSchoolGradeName(item);
    });
    this.localSort.set(this.data.list);
    this.searchValue.value = _.cloneDeep(this.data.list);
  }

  // 검색
  async function search() {
    this.checkedDepth1.splice(0, this.checkedDepth1.length);
    this.checkedDepth2.splice(0, this.checkedDepth2.length);
    this.checkedDepth3.splice(0, this.checkedDepth3.length);
    const params = this.data.params;
    const result = await getLmTextBookList(params);
    this.setResultDataList(result);
  }

  // 학교급 검색
  async function gradesearch(data) {
    const params = this.data.params;
    const result = await getLmTextBookListSchlGrade(params);
    this.setResultDataList(result);
  }

  // 상세
  async function edit(bookSeq){
    this.data.params.mode = 'detail';
    this.data.detailBookSeq = bookSeq;
  }

  // 단원/차시/개체 목록
  async function searchDepth(resultData) {
    // 단원/차시/개체에서 data.row 를 사용하는 곳이 있어서 추가로 전달
    this.data.row = resultData;

    const orgContSeq = resultData.orgContSeq;
    const contSeq = resultData.contSeq;
    this.getAtrbList(orgContSeq, contSeq, '202004'); // 목차
  }

  // 초기화
  async function reset(){
    this.dataAction.clear();
  }
  // -------------------------------------------------------------
  // Ycloud > LMS 교재 가져오기
  async function saveYcloudBook(bookInfo){
    this.modalLoading = true;
    typeNmToCd(bookInfo);

    let param = {
      textbookId : bookInfo.textbookId,
      limit : 10000
    }

    let atrbInfoResult = await getTextbookAtrbRelInfoList(param); //await -> 비동기 처리
    let saveParam = {
      textbookMstVo : bookInfo,  // 교재정보
      textbookAtrbRelInfoList : atrbInfoResult.data, // 목차, 단원, 차시, 개체
      // textbookContentsList : contentsMstResult.data
    }

    let bookResult = await saveTextbook (saveParam);
    let contSeq = bookResult.data
    this.modalLoading = false;
    this.$bvModal.hide('bookModal')
    swal({
      title: "Ycloud 교재 내려받기",
      text: "데이터 내려받기 완료",
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "OK",
      heightAuto: false
    }).then((result) => {
      if(result.value){
        this.$router.go(this.$router.currentRoute);
      }
    });
  }

  function typeNmToCd(bookInfo){
    // 학교급 체크
    let schlGrade = subjectCd1; // 초등과목
    if(bookInfo.schlM1ChkYn == 'Y' || bookInfo.schlM2ChkYn == 'Y' || bookInfo.schlM3ChkYn == 'Y'){ // 중등과목
      schlGrade = subjectCd2;
    } else if(bookInfo.schlH1ChkYn == 'Y' || bookInfo.schlH2ChkYn == 'Y' || bookInfo.schlH3ChkYn == 'Y') { // 고등과목
      schlGrade = subjectCd3;
    }
    // 교과목 코드설정
    if(bookInfo.subjectTypeNm == '1012' || bookInfo.subjectTypeNm == '1014' || bookInfo.subjectTypeNm == '1015' || bookInfo.subjectTypeNm == '1016' 
    || bookInfo.subjectTypeNm == '1017' || bookInfo.subjectTypeNm == '1018' || bookInfo.subjectTypeNm == '1099'){ // 기타과목인경우
      if(schlGrade == subjectCd1){ // 초등기타과목
        bookInfo.subjectCd = '328099';
      }else if(schlGrade == subjectCd2){ // 중등기타과목
        bookInfo.subjectCd = '328199';
      }else { // 고등기타과목
        bookInfo.subjectCd = '328299';
      }
      
    } else { // 기타과목이 아닌경우
      let subject = _.find(schlGrade,{refValue: bookInfo.subjectTypeNm});
      bookInfo.subjectCd = subject.value;
    }
  }

  function clearAtrbInfo(){
    let _atrInfo = this.atrbInfo;
    _atrInfo.result = {};
    _atrInfo.depth1 = []; // 단원 : 202004, 목차 : 202005
    _atrInfo.depth2 = []; // 차시 : 202006, 코너 : 202007
    _atrInfo.files = []; // file
    return _atrInfo;
  }

 // [단원 : 202004, 목차 : 202005], 차시 : 202006, 코너 : 202007
  async function getAtrbList(orgContSeq , contSeq , postTypeCd) {
    let _atrInfo = this.clearAtrbInfo();
    if(orgContSeq == null){
      orgContSeq = contSeq;
    }
    let param = {
      pContSeq: orgContSeq,
      contTypeCd: '201002',  // 교재
      //postTypeCd: postTypeCd,
      sort: 'order_num',
      limit: 10000
    }

    let result = await getCsContTreeList(param)
    _atrInfo.result = result.data;
    result.data.forEach(function(e) {
      if (postTypeCd == '202004') {
        if (e.postTypeCd == '202004' || e.postTypeCd == '202005') {
          _atrInfo.depth1.push(e)
        }
      }
    });

     _atrInfo.depth1.sort(function(a,b){
       return a.orderNum - b.orderNum;
     })

    this.getDepth3(contSeq);
  }

  async function getAtrbListExcel(contSeq, postTypeCd, itemAtrbInfo , orgContSeq) {
    this.atrbInfo = itemAtrbInfo;
    let _atrInfo = this.clearAtrbInfo();
    
    let param = {
      pContSeq: contSeq,  //개체정보는 contSeq 에 orgContSeq 가 들어있음.
      contTypeCd: '201002',  // 교재
      //postTypeCd: postTypeCd,
      sort: 'order_num',
      limit: 10000
    }

    let result = await getCsContTreeList(param)
    _atrInfo.result = result.data;
    result.data.forEach(function(e) {
      if (postTypeCd == '202004') {
        if (e.postTypeCd == '202004' || e.postTypeCd == '202005') {
          _atrInfo.depth1.push(e)
        }
      }
    });
    
    _atrInfo.depth1.sort(function(a,b){
       return a.orderNum - b.orderNum;
     })

    this.getDepth3Excel(contSeq , itemAtrbInfo) // orgContSeq에 ContSeq가 들어있음
  }

  // draggable 체크 :
  function shouldDragToPosition(event) {
    if (event.related) {
      const draggedSeqs = event.dragged.id.split('_');
      const relatedSeqs = event.related.id.split('_');
      
      if (draggedSeqs.length == 3 && relatedSeqs.length == 3) {
        //console.log(`dragged:${draggedSeqs[1]}, related:${relatedSeqs[1]}`);
        const dragType = draggedSeqs[0];
        if (dragType == '202006') { // 차시, 무조건 이동
          return true;
        } else { // 코너, 코너의 부모 seq 로 체크, 같은 차시내에서만 이동
          return true;
        }
      } else {
        return true;
      }
    }
  }

  // 차시정보
  async function getDepth3(_contSeq){
    let _atrInfo = this.atrbInfo;
    if (!_atrInfo.result.length) {
      let param = {
        pContSeq: _contSeq,
        contTypeCd: '201002',  // 교재
        //postTypeCd: postTypeCd,
        sort: 'order_num',
        limit: 10000
      }

      let result = await getCsContTreeList(param)
      _atrInfo.result = result.data;
    }
    
    _atrInfo.depth2 = [];
    _atrInfo.result.forEach(function(e) {
      if (e.postTypeCd=='202006' && e.pcontSeq == _contSeq ) {
        _atrInfo.depth2.push(e)
        _atrInfo.result.forEach(function(f) {
          if (f.postTypeCd=='202007' && f.pcontSeq == e.contSeq ) {
            _atrInfo.depth2.push(f)
          }
        })
      }
    });
    _atrInfo.depth2.sort(function(a,b){
      return a.orderNum - b.orderNum;
    });
    this.atrbInfo.targetContSeq = _contSeq;
    if(_contSeq != undefined){
      this.getAtrbFiles(_contSeq)
    }
  }

   // 엑셀 차시정보
  async function getDepth3Excel(_contSeq , atrbInfo , item){
    let _atrInfo = atrbInfo;
    _atrInfo.depth2 = [];

    let param = {
      pContSeq: _contSeq,
      contTypeCd: '201002',  // 교재
      //postTypeCd: postTypeCd,
      sort: 'order_num',
      limit: 10000
    }

    let result = await getCsContTreeList(param)
    _atrInfo.result = result.data;
    // result.data.forEach(function(e) {
    //   if (e.postTypeCd == '202004' || e.postTypeCd == '202005') {
    //     _atrInfo.depth1.push(e)
    //   }
    // });
    //  _atrInfo.depth1.sort(function(a,b){
    //    return a.orderNum - b.orderNum;
    //  })

    _atrInfo.depth2 = [];
    result.data.forEach(function(e) {
      if (e.postTypeCd=='202006' && e.pcontSeq == _atrInfo.targetContSeqDepth1 ) {
        _atrInfo.depth2.push(e)
        _atrInfo.result.forEach(function(f) {
          if (f.postTypeCd=='202007' && f.pcontSeq == e.contSeq ) {
            _atrInfo.depth2.push(f)
          }
        })
      }
    });
     _atrInfo.depth2.sort(function(a,b){
       return a.orderNum - b.orderNum;
    });
   
    if((_atrInfo.targetContSeqDepth1||0) > 0){
      if((_atrInfo.targetContSeqDepth2||0) > 0){
        _contSeq = _atrInfo.targetContSeqDepth2;
      }
      else{
         _contSeq = _atrInfo.targetContSeqDepth1;
      }
    }   
   
    this.getAtrbFiles(_contSeq)
  }

  async function _getAtrbFiles(item) {
    this.atrbInfo = item.atrbInfo;

    let contSeq = item.contSeq;
    if((item.atrbInfo.targetContSeqDepth1||0) > 0){
      if((item.atrbInfo.targetContSeqDepth2||0) > 0){
        contSeq = item.atrbInfo.targetContSeqDepth2;
      }
      else{
        contSeq = item.atrbInfo.targetContSeqDepth1;
      }
    }

    this.getAtrbFiles(contSeq);
  }

  // 개체 파일
  async function getAtrbFiles(contSeq){
    const contKind = [];
    const contColor = [];

    let param = {
      contSeq : contSeq,
      sort: 'order_num',
      limit : 10000
    }
    this.atrbInfo.files = [];
    let result = await getCsFileListByMapp(param)
    if(result.data.length != 0){
      this.atrbInfo.files = result.data;
    
      this.atrbInfo.files.map ((row, i) =>{ //용도 색&텍스트 설정
        switch(row.purpTypeCd){
          case '209001' : 
          contKind[i]='수업용1';
          contColor[i]="#008000";
          break;

          case '209002' :
          contKind[i]='수업용2';
          contColor[i]="#0000FF";
          break;

          case '209003' : 
          contKind[i]='과제용';
          contColor[i]="#800080";
          break;

          case '209004' :
          contKind[i]='평가용';
          contColor[i]="#FF8C00";
          break;

          case '209005' : 
          contKind[i]='연구용';
          contColor[i]="#FF00FF";
          break;   
        }
        if (row.purpTypeCd == '209007' || (row.purpTypeCd||'').startsWith('6')) {
          contKind[i]='부가자료';
          contColor[i]="#FF00FF";
        }
      });
      this.atrbInfo.contKind = contKind;
      this.atrbInfo.contColor = contColor;
      this.atrbInfo.contSeq = contSeq;
    }
  }

  async function getAtrbUsingFiles(_contSeq , _atrbInfo){
    this.atrbInfo = _atrbInfo;
    this.atrbInfo.contSeq = _contSeq;
    
    let param = {
      contSeq : _contSeq,
      sort: 'order_num',
      limit : 10000
    }
    let result = await getCsFileListByMapp(param)

    if(result.data.length > 0){
      this.atrbInfo.files = result.data;
    }
    
  }

  async function findFile(fileSeq){
    this.atrbInfo.fileSeq = fileSeq
  }

  //드래그 순서 변경 함수 
  function changeOrder(atrbInfo,depth3) {
     let _temp = []; // 최종 orderNum
     let _tempData = [];
      
      for(var i = 0; i < this.changeData.length; i++){
         _temp[i] = this.changeData[i].orderNum;
      }

      for(var i = 0; i< atrbInfo.length; i++){
        _tempData.push(atrbInfo[i]);
        _tempData[i].orderNum = _temp[i];
      }
  }

  //드래그 순서 저장 함수 
  function saveChangeOrder(depth) {
     if(depth == 'depth1'){
        saveCsContList(this.atrbInfo.depth1);
        this.changeData = _.cloneDeep(this.atrbInfo.depth1);
      }
      else if(depth == 'depth2'){
        saveCsContList(this.atrbInfo.depth2);
        this.changeData = _.cloneDeep(this.atrbInfo.depth2);
      } 
      else{
        saveCsFileMappingList(this.atrbInfo.files);
        this.changeData = _.cloneDeep(this.atrbInfo.files);
      }
  }

  //드래그 순서 편집 함수 
  function clickChangeData(depth) {  
       if(depth == 'depth1'){
        this.changeData = _.cloneDeep(this.atrbInfo.depth1);
      }
      else if(depth == 'depth2'){
        this.changeData = _.cloneDeep(this.atrbInfo.depth2);
      }
      else{
        this.changeData = _.cloneDeep(this.atrbInfo.files);
      }
  }

  //드래그 순서 취소 함수 
  function resetOrderNum(depth) {  
    if(depth == 'depth1'){
      this.atrbInfo.depth1 = _.cloneDeep(this.changeData);
    }else if(depth == 'depth2'){
      this.atrbInfo.depth2 = _.cloneDeep(this.changeData);
    }else{
      this.atrbInfo.files = _.cloneDeep(this.changeData);
    }
  }

  function editAttr(_contSeq) {
    this.editContSeq = this.editContSeq==_contSeq?0:_contSeq;
  }

  async function saveAttr(item_title, pcont_seq){
    console.log('## saveAttr',this.editContSeq)
    let params = {
      contSeq : this.editContSeq,
      title : item_title,
      pcontSeq: pcont_seq,
    }
    await saveCsCont(params);
    this.editContSeq=0;
  }

  async function saveAttrFile(item_title, fileSeq,item){
    console.log('## saveAttrFile',this.editContSeq)
    item.dispFileNm = item_title;

    let result = await saveCsFile(item);
    if(result != null){
      alert("변경되었습니다.");
      this.editContSeq=0;
      this.isShowfiles = false;
    }
  }

  async function deleteAttr(book_contSeq, item_contSeq , index , atrbInfo, version){
    console.log('## deleteAttr',this.editContSeq)

    this.popupShowFile = false;
    let _contSeq = null;
    

    if(version == 'file'){
      this.popupShowFile = false;
      // 개체 부분은 book_contSeq가 fileSeq 로 대체됨 index 는 contSeq
      let params = {
        fileSeq : book_contSeq,
        contSeq : index,
        mappingSeq : item_contSeq,
      }
      this.popupShowFile = false;
      await deleteCsFileMapping(params);
      atrbInfo.files.splice(index ,1);
    }
    else{
      let params = {
        contSeq : this.editContSeq,
      }
      await deleteCsCont(params);
      version == 'unit' ? atrbInfo.depth1.splice(index - 1 ,1) : atrbInfo.depth2.splice(index - 1 ,1);
    }

    if(atrbInfo.targetContSeqDepth1 != null){
      _contSeq = atrbInfo.targetContSeqDepth1;
    }else{
      _contSeq = book_contSeq;
    }
    await this.getAtrbList(book_contSeq, _contSeq ,'202004'); // 목차

    this.editContSeq=0;
    this.isShowDepth2 = false;
  }
  
function removeAtrbInfo(contSeq){
  reactive(atrbInfo.result).forEach(function(e) {
      if (e.contSeq==contSeq ) {
        // delete e ;
      }
  });
}

async function getDepthData(item) {
  if(item.version == 'fileUsing'){
    if(item.postTypeCd == '202004'){
      await this.getAtrbListExcel(item.orgContSeq,'202004' , item.atrbInfo , item.contSeq);
    }
    else{
      await this.getAtrbListExcel(item.orgContSeq,'202004' , item.atrbInfo , item.contSeq);
      await this.getDepth3Excel(item.contSeqDepth1 ,item.atrbInfo , item);
      //await this.getAtrbUsingFiles(item.contSeq);
    }
  }
  else{
    this.getAtrbListExcel(item.contSeq,'202004' , item.atrbInfo , null );
  }
}

async function saveUploadlist(item,type) {
    if(type =='excel'){
        await saveCsContExcel(item.params);
    }
    else{
      await saveCsCont(item.params);
    }
    if( item.version == 'unit'){
      this.getAtrbListExcel(item.delete_param.contSeq, '202004' , item.atrbInfo , null);
    }
    else{
      //this.getAtrbListExcel(item.delete_param.contSeq, '202004' , item.atrbInfo);
      this.getDepth3Excel(item.delete_param.contSeq , item.atrbInfo , item.params);
    }
  }

const downloadAs = (fileDivCd, url, name) => {
        let fullUrl = aws_cdn_path + url;
        Axios.get(fullUrl, {
        headers: {
          "Content-Type": "application/octet-stream"
        },
        responseType: "blob"
      })
        .then(response => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(response.data);
          a.href = url;
          a.download = name;
          a.click();
        })
        .catch(err => {
          console.log("error", err);
        });
    };

  return {reset, search, edit, searchDepth, gradesearch,setResultDataList,
      shouldDragToPosition,
      saveYcloudBook,
      typeNmToCd,
      getAtrbList,
      getAtrbListExcel,
      getDepth3,
      getDepth3Excel,
      getDepthData,
      getAtrbFiles,
      _getAtrbFiles,
      saveAttrFile,
      getAtrbUsingFiles,
      clearAtrbInfo,
      findFile,
      changeOrder,
      editAttr,
      saveAttr,
      deleteAttr,
      saveUploadlist,
      clickChangeData,
      resetOrderNum,
      saveChangeOrder,
      downloadAs,
    }
}

</script>
